import React from 'react'
import Media from 'react-media'

import { HeartOutline, HomeDelivery } from '@cinch/oxd-components/icons/src'
import List, { ListItem } from '@cinch/oxd-components/list/src'
import Text, { TextStyles } from '@cinch/oxd-components/text/src'
import tokens from '@cinch/oxd-utils/tokens/src'

import DeliveryModal from './components/delivery-modal'
import Toggle from './components/toggle'

import * as styles from './delivery-preference.module.css'

export interface Delivery {
  deliveryPreference: Cinch.WebAppTranslations['findVehicle']['deliveryPreference']
  deliveryModal: Cinch.WebAppTranslations['findVehicle']['deliveryModal']
}

export interface DeliveryPreferenceProps {
  i18n: Delivery
  isSelected: boolean
  onChange: (isSelected: boolean) => any
}

const DeliveryPreference: React.FC<DeliveryPreferenceProps> = ({ i18n, onChange, isSelected = false }) => {
  const [isStateSelected, setIsStateSelected] = React.useState<boolean>(isSelected)
  const [isDeliveryModalOpen, setIsDeliveryModalOpen] = React.useState<boolean>(false)

  const handleModal = () => setIsDeliveryModalOpen(!isDeliveryModalOpen)

  const HomeDeliveryIcon = HomeDelivery as any

  const handleToggleClick = () => {
    onChange(!isSelected)
    setIsStateSelected(!isSelected)
  }

  React.useEffect(() => {
    if (isStateSelected !== isSelected) {
      setIsStateSelected(isSelected)
    }
  }, [isSelected])

  return (
    <div className={styles.delivery}>
      <div className={styles.header}>
        <div className={styles.headerText}>
          <div className={styles.iconContainer}>
            <HomeDeliveryIcon role="presentation" />
          </div>
          <Text type={TextStyles.bullet} className={styles.headerLink} onClick={handleModal}>
            {i18n.deliveryPreference.moreInfo}
          </Text>
          {isDeliveryModalOpen && <DeliveryModal i18n={i18n.deliveryModal} onClose={handleModal} />}
        </div>
        <Media query={tokens.customMedia.m}>
          {(matches) => (
            <Toggle
              isSelected={isStateSelected}
              onClick={handleToggleClick}
              selectedLabel={i18n.deliveryPreference.onLabel}
              unselectedLabel={i18n.deliveryPreference.offLabel}
              size={matches ? 'mini' : 'regular'}
            />
          )}
        </Media>
      </div>
      <div className={styles.content}>
        <List className={styles.list}>
          <ListItem bulletIcon={HeartOutline} className={styles.listItem}>
            {i18n.deliveryPreference.bullet1}
          </ListItem>
          <ListItem bulletIcon={HeartOutline} className={styles.listItem}>
            {i18n.deliveryPreference.bullet2}
          </ListItem>
        </List>
      </div>
    </div>
  )
}

export default DeliveryPreference
